import "@arco-design/web-react/es/ConfigProvider/style";
import _ConfigProvider from "@arco-design/web-react/es/ConfigProvider";
import './style/global.less';
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { createStore } from 'redux';
import { Provider } from 'react-redux';
import zhCN from '@arco-design/web-react/es/locale/zh-CN';
import enUS from '@arco-design/web-react/es/locale/en-US';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import axios from 'axios';
import rootReducer from './store';
import PageLayout from './layout';
import { GlobalContext } from './context';
import Login from './pages/login';
import checkLogin from './utils/checkLogin';
import changeTheme from './utils/changeTheme';
import useStorage from './utils/useStorage';
import './mock';
const store = createStore(rootReducer); // 全局 401 兜底：令牌缺失/过期/无效时，管理端所有 /api/v1/admin/* 请求都会返回 401。
// 此时清理本地登录态并回到登录页，避免过期令牌导致全部接口持续 401（§5.1 adminapi 鉴权）。

axios.interceptors.response.use(response => response, error => {
  if (error?.response?.status === 401) {
    localStorage.removeItem('token');
    localStorage.setItem('userStatus', 'logout');

    if (window.location.pathname.replace(/\//g, '') !== 'login') {
      window.location.pathname = '/login';
    }
  }

  return Promise.reject(error);
});

function Index() {
  const [lang, setLang] = useStorage('arco-lang', 'en-US');
  const [theme, setTheme] = useStorage('arco-theme', 'light');

  function getArcoLocale() {
    switch (lang) {
      case 'zh-CN':
        return zhCN;

      case 'en-US':
        return enUS;

      default:
        return zhCN;
    }
  }

  function fetchUserInfo() {
    store.dispatch({
      type: 'update-userInfo',
      payload: {
        userLoading: true
      }
    }); // 运营身份取自管理端 /api/v1/admin/me（Default 信封），据 subject 回填展示名。

    axios.get('/api/v1/admin/me').then(res => {
      const me = res.data?.data || {};
      store.dispatch({
        type: 'update-userInfo',
        payload: {
          userInfo: {
            name: me.subject,
            permissions: {}
          },
          userLoading: false
        }
      });
    }).catch(() => {
      store.dispatch({
        type: 'update-userInfo',
        payload: {
          userLoading: false
        }
      });
    });
  }

  useEffect(() => {
    // 登录签发的 JWT 统一挂到 axios 默认头，供后续 /api/v1/admin/* 请求携带（§5.1 adminapi 鉴权）。
    const token = localStorage.getItem('token');

    if (token) {
      axios.defaults.headers.common.Authorization = `Bearer ${token}`;
    }

    if (checkLogin()) {
      fetchUserInfo();
    } else if (window.location.pathname.replace(/\//g, '') !== 'login') {
      window.location.pathname = '/login';
    }
  }, []);
  useEffect(() => {
    changeTheme(theme);
  }, [theme]);
  const contextValue = {
    lang,
    setLang,
    theme,
    setTheme
  };
  return /*#__PURE__*/React.createElement(BrowserRouter, null, /*#__PURE__*/React.createElement(_ConfigProvider, {
    locale: getArcoLocale(),
    componentConfig: {
      Card: {
        bordered: false
      },
      List: {
        bordered: false
      },
      Table: {
        border: false
      }
    }
  }, /*#__PURE__*/React.createElement(Provider, {
    store: store
  }, /*#__PURE__*/React.createElement(GlobalContext.Provider, {
    value: contextValue
  }, /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
    path: "/login",
    component: Login
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/",
    component: PageLayout
  }))))));
}

ReactDOM.render( /*#__PURE__*/React.createElement(Index, null), document.getElementById('root'));